<template>
  <div class="modal-container">
    <dl>
      <slot name="modal-header">タイトル</slot>
      <slot name="modal-body"></slot>
      <slot name="modal-footer"></slot>
    </dl>
  </div>
</template>
<script>export default {
    name: 'ModalWindow',    
    data() {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Utility/ModalWindow.vue